import {POLICY_HEGEMONISM_BONUS_HEX_KEYS} from "../../../configs/policy/hegemonism";

export const isHegemonismBonusHexKey = (hexKey) => {
  return POLICY_HEGEMONISM_BONUS_HEX_KEYS.includes(hexKey);
}